import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTABanner() {
  return <section className="bg-gold-accent py-[80px] px-[40px] text-center" data-id="element-166">
      <div className="max-w-[520px] mx-auto" data-id="element-167">
        <h2 className="font-serif italic text-[30px] md:text-[34px] text-primary-dark mb-5 leading-tight" data-id="element-168">
          Still reading?
          <br data-id="element-169" />
          Then you already know
          <br data-id="element-170" />
          this is the system you've been missing.
        </h2>

        <p className="font-sans text-[18px] text-primary-dark mb-8 leading-relaxed" data-id="element-171">
          10 chapters. 19 tools. 7 scripts. 90 days.
          <br data-id="element-172" />
          One phone call that pays for everything.
          <br data-id="element-173" />
          15 minutes a week from this Sunday forward.
        </p>

        <CTAButton subText="Instant download · Chapter 5 money-back guarantee" className="w-full" data-id="element-174">
          GET THE DEBT-FREE SYSTEM → $9.99
        </CTAButton>
      </div>
    </section>;
}